export function getEnvValue(key, defaultValue = null) {
    // window.config is injected at container start (inject-env.sh) and
    // won't exist in local dev — hence the optional chaining. The
    // process.env fallback only works for REACT_APP_-prefixed keys (CRA).
    return window.config?.[key] ?? process.env[`REACT_APP_${key}`] ?? defaultValue;
}